var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wp-reviewer-comments" }, [
    _c(
      "div",
      {
        staticClass: "wp-reviewer-comments__grid",
        class: {
          "wp-reviewer-comments__grid--single": !_vm.showExternalColumn,
          "wp-reviewer-comments__grid--split": _vm.isSplitTextareas,
        },
      },
      [
        _vm.showInternalHeader
          ? _c("div", { staticClass: "wp-reviewer-comments__head-internal" }, [
              _c("p", { staticClass: "workpermit-content-slot__review_hint" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.firstCellHeaderDisplay) + "\n      "
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showExternalColumn
          ? _c("div", { staticClass: "wp-reviewer-comments__head-external" }, [
              _c(
                "div",
                { staticClass: "wp-reviewer-comments__external-head" },
                [
                  _c(
                    "p",
                    { staticClass: "workpermit-content-slot__review_hint" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.externalHeaderDisplay) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "wp-reviewer-comments__cell-internal",
            class: {
              "wp-reviewer-comments__cell-internal--full":
                _vm.cellInternalFullWidth,
            },
          },
          [
            _c("TextField", {
              staticClass: "workpermit-content-slot__review-text-input",
              attrs: {
                showColon: false,
                required: _vm.internalRequired,
                readonly: _vm.readonly,
                readonlyAsInput: _vm.readonly,
                placeholder: _vm.firstCellPlaceholder,
                extendClass: _vm.firstCellRejectErrorClass,
                value: _vm.internalValue,
              },
              on: {
                updateValue: function (val) {
                  return _vm.$emit("update:internalValue", val)
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showExternalColumn && _vm.showExternalTextarea
          ? _c(
              "div",
              { staticClass: "wp-reviewer-comments__cell-external" },
              [
                _c("TextField", {
                  staticClass: "workpermit-content-slot__review-text-input",
                  attrs: {
                    showColon: false,
                    required: _vm.leaveExternalValue,
                    readonly: _vm.readonly,
                    readonlyAsInput: _vm.readonly,
                    placeholder: _vm.$t(
                      "workPermit.externalCommentsPlaceholder"
                    ),
                    value: _vm.externalValue,
                    extendClass: _vm.externalError
                      ? "wp-reviewer-comments__external-text--reject-error"
                      : "",
                  },
                  on: {
                    updateValue: function (val) {
                      return _vm.$emit("update:externalValue", val)
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }